import * as Sentry from '@sentry/vue';
import { Stage } from '../enums/app-config';

export function initLogger() {
  // if (appConfig.stage === Stage.DEV) {
  //   return;
  // }

  const stageMapping = {
    [Stage.LIVE]: 'FE-live',
    [Stage.TEST]: 'FE-test',
    [Stage.DEV]: 'FE-dev',
  };

  Sentry.init({
    dsn: 'https://283574c00547490684d89a0eda42146f@o144610.ingest.us.sentry.io/1187521',
    environment: stageMapping[appConfig.stage],
  });
}

export function logError(error: Error, text?: string) {
  error.message = [error.message, text].filter(Boolean).join('---');
  console.error(error);
  Sentry.captureException(error);
}
